import { mytClock, mytDayLabel } from '../../utils/myt.js';

/** 408 (#1434): a car's fuel as `GET /cars/:id` and a booking's `car` publish it to staff (contracts/api.md). */
export interface CarFuel {
  percent: number;
  read_at: string | null;
  bars_total: number;
  bars_filled: number;
  litres?: number | null;
}

/**
 * 408 (mock-up screens 4–5): the fuel as bars on the car's own gauge (the platform decides how many are full), with the
 * percentage, the litres and when Cartrack read it, in Malaysia time.
 */
export function FuelBars({ fuel }: { fuel: CarFuel }) {
  const words = `${fuel.bars_filled} of ${fuel.bars_total} bars · ${fuel.percent}%${
    typeof fuel.litres === 'number' ? ` · ${fuel.litres} L` : ''
  }`;
  return (
    <div data-testid="fuel-bars">
      <span
        role="img"
        aria-label={`Fuel ${words}`}
        className="mr-2 inline-flex gap-0.5 align-middle"
      >
        {Array.from({ length: fuel.bars_total }, (_, i) => (
          <span
            // biome-ignore lint/suspicious/noArrayIndexKey: the bars are positions on a fixed gauge
            key={i}
            data-bar={i < fuel.bars_filled ? 'on' : 'off'}
            className={`h-3.5 w-2.5 rounded-sm ${i < fuel.bars_filled ? 'bg-primary' : 'bg-hairline-strong'}`}
          />
        ))}
      </span>
      {words}
      {fuel.read_at && (
        <div className="mt-0.5 text-xs text-steel">
          as of {mytDayLabel(fuel.read_at)}, {mytClock(fuel.read_at)}
        </div>
      )}
    </div>
  );
}
